var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{staticClass:"w-full h-full",attrs:{"src":_vm.iFrameUrl,"controls":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }